import { render, staticRenderFns } from "./game-list-navi.vue?vue&type=template&id=5ac6ebaa&"
import script from "./game-list-navi.vue?vue&type=script&lang=js&"
export * from "./game-list-navi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports